import { ShellUX } from './ux.js';
export class UXPlugin {
    constructor(shell) {
        this.getUserIdCookie = () => {
            const latestCookies = document.cookie;
            const userIdCookie = latestCookies
                .split(';')
                .find((item) => item.includes('USERID'));
            if (userIdCookie) {
                return userIdCookie.split('=')[1];
            }
            return '';
        };
        this.shell = shell;
        this.shellUX = new ShellUX(this.shell);
        this.shellUX.registerSidebar('account');
        this.shellUX.registerSidebar('notifications');
        this.shellUX.registerSidebar('menu');
        this.shellUX.registerProgress();
        this.shellUX.registerPreloader();
    }
    isAccountSidebarVisible() {
        return this.shellUX.isSidebarVisible('account');
    }
    isAccountSidebarLargeScreenDisplayForced() {
        return this.shellUX.isLargeScreenDisplayForced('account');
    }
    showAccountSidebar() {
        return this.shellUX.showSidebar('account');
    }
    isMenuSidebarVisible() {
        return this.shellUX.isSidebarVisible('menu');
    }
    showMenuSidebar() {
        return this.shellUX.showSidebar('menu');
    }
    hideAccountSidebar() {
        return this.shellUX.hideSidebar('account');
    }
    hideMenuSidebar() {
        return this.shellUX.hideSidebar('menu');
    }
    onUpdateMenuSidebarItemLabel(callback) {
        this.sidebarMenuUpdateItemLabelListener = callback;
    }
    updateMenuSidebarItemLabel(serviceName, label) {
        if (this.sidebarMenuUpdateItemLabelListener) {
            this.sidebarMenuUpdateItemLabelListener(serviceName, label);
        }
    }
    setForceAccountSiderBarDisplayOnLargeScreen(isForced) {
        this.shellUX.setForceSiderBarDisplayOnLargeScreen('account', isForced);
    }
    resetAccountSidebar() {
        this.shellUX.resetSidebar('account');
    }
    toggleAccountSidebarVisibility() {
        this.shellUX.toggleSidebarVisibility('account');
    }
    onAccountSidebarVisibilityChange(callback) {
        this.shellUX.onSidebarVisibilityChange('account', callback);
    }
    isNotificationsSidebarVisible() {
        return this.shellUX.isSidebarVisible('notifications');
    }
    showNotificationsSidebar() {
        return this.shellUX.showSidebar('notifications');
    }
    hideNotificationsSidebar() {
        return this.shellUX.hideSidebar('notifications');
    }
    toggleNotificationsSidebarVisibility() {
        this.shellUX.toggleSidebarVisibility('notifications');
    }
    onNotificationsSidebarVisibilityChange(callback) {
        this.shellUX.onSidebarVisibilityChange('notifications', callback);
    }
    getSSOAuthModalMode(oldUserID) {
        const latestUserIdCookie = this.getUserIdCookie();
        if (oldUserID && !latestUserIdCookie) {
            return 'CONNECTED_TO_DISCONNECTED';
        }
        if (!oldUserID && latestUserIdCookie) {
            return 'DISCONNECTED_TO_CONNECTED';
        }
        if (oldUserID !== latestUserIdCookie) {
            return 'CONNECTED_TO_OTHER';
        }
        return '';
    }
    isChatbotReduced() {
        return this.shellUX.getChatbot().isReduced();
    }
    isChatbotVisible() {
        return this.shellUX.getChatbot().getVisibility();
    }
    openLiveChat() {
        this.shellUX.openChatbot();
    }
    closeChatbot() {
        this.shellUX.closeChatbot();
    }
    reduceChatbot() {
        this.shell.emitEvent('ux:reduce-chatbot');
    }
    onChatbotVisibilityChange(callback) {
        this.shellUX.getChatbot().onVisibilityChange(callback);
    }
    startProgress() {
        this.shellUX.startProgress();
    }
    stopProgress() {
        this.shellUX.stopProgress();
    }
    onProgressStart(callback) {
        this.shellUX.onProgressStart(callback);
    }
    onProgressStop(callback) {
        this.shellUX.onProgressStop(callback);
    }
    showPreloader() {
        this.shellUX.showPreloader();
    }
    onShowPreloader(callback) {
        this.shellUX.onShowPreloader(callback);
    }
    removeOnShowPreloader(callback) {
        this.shellUX.removeOnShowPreloader(callback);
    }
    hidePreloader() {
        this.shellUX.hidePrelaoder();
    }
    onHidePreloader(callback) {
        this.shellUX.onHidePreloader(callback);
    }
    removeOnHidePreloader(callback) {
        this.shellUX.removeOnHidePreloader(callback);
    }
    requestClientSidebarOpen() {
        this.shell.emitEvent('ux:client-sidebar-open');
    }
    registerModalActionDoneListener(callback) {
        this.onModalActionDone = callback;
    }
    unregisterModalActionDoneListener(callback) {
        if (this.onModalActionDone === callback) {
            this.onModalActionDone = undefined;
        }
    }
    notifyModalActionDone(id) {
        if (this.onModalActionDone) {
            this.onModalActionDone(id);
        }
    }
}
//# sourceMappingURL=index.js.map